import React from 'react';
import { Row, Col } from 'react-bootstrap';

import SATextInput from './SATextInput';
import PhoneNumber from './PhoneNumber';

export default function ContactInformation(props) {
    const register = props?.register;
    const errors = props?.errors;
    const control = props?.control 

   

    return (
        <React.Fragment>
            <Row>
                
                <Col lg={4}>
                    <PhoneNumber
                        register={register}
                        errors={errors}
                        control={control}
                        htmlFor={props.htmlForCellNumber}
                        name={props.cellPhoneName}
                        isStrong={true}
                        label={"Cell Number:"}
                        requiredObj={{ required: "Cell Number is required!", 
                        pattern: { value: /\([0-9]{3}\)[0-9]{3}-[0-9]{4}/, 
                        message: "Invalid Cell Number!" }}}
                        maskValue={"(999)999-9999"}
                        type={"text"}
                        placeholder={"Cell Number (required)"}
                        id={props.cellPhoneId}
                        errMsg={props?.cellPhoneErrMsg}
                    />
                </Col>
                <Col lg={4}>
                    <PhoneNumber
                        register={register}
                        errors={errors}
                        control={control}
                        htmlFor={props.htmlForHomePhone}
                        name={props.homePhoneName}
                        isStrong={false}
                        label={"Home Phone:"}
                        requiredObj={{ 
                        pattern: { value: /\([0-9]{3}\)[0-9]{3}-[0-9]{4}/, 
                        message: "Invalid Home Phone!" } }}
                        maskValue={"(999)999-9999"}
                        type={"text"}
                        placeholder={"Home Phone "}
                        id={props.homePhoneId}
                        errMsg={props?.homePhoneErrMsg}
                    />
                </Col>
                <Col lg={4}>
                    
                        <SATextInput
                            register={register}
                            htmlFor={props.htmlForEmailAddress}
                            name={props.emailAddressName}
                            label={"Email Address:"}
                            isStrong={true}
                            type={"text"}
                            placeholder={"Email Address (required)"}
                            errors={errors}
                            id={props.emailAddressId}
                            maxLength={64}
                            errMsg={props?.emailAddressErrMsg}
                            requiredObj={{
                                required: "Email Address is required!"
                                , pattern: {
                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,25}$/
                                    , message: "Invalid Email Address!"
                                }
                            }
                            }
                        />
                   
                </Col>
            </Row>
        </React.Fragment>

    )
}